import {
  ThemeProvider,
  CookiesProvider,
  ToastContainer,
  UserInfoProvider,
  AppBanner,
  LoginSignupModalWrapper
} from '@spotahome/ui-library';
import { useSoyuzData } from '@spotahome/soyuz/client';

import '@spotahome/landings-common/src/scss/init.scss';

import StaticPage from './components/StaticPage';

const StaticPageContainer = () => {
  const { [StaticPageContainer.NAME]: requestedData } = useSoyuzData();
  const data = requestedData;

  return (
    <CookiesProvider initialCookie={requestedData.initialCookie}>
      <ThemeProvider flags={{ newButtons: true }}>
        <UserInfoProvider>
          <ToastContainer />
          <AppBanner source="home" deviceType={requestedData.deviceType} />
          <StaticPage data={data} />
          <LoginSignupModalWrapper
            deviceViewType={requestedData.deviceViewType}
          />
        </UserInfoProvider>
      </ThemeProvider>
    </CookiesProvider>
  );
};

StaticPageContainer.NAME = 'StaticPageContainer';

export default StaticPageContainer;
